import api from '@/http'
import moment from 'moment'
import jstz from 'jstz'
import _ from 'lodash'

export default {
  data () {
    return {
      selectedEvents: {}
    }
  },
  methods: {
    fetchCalendarEvents (from, until) {
      // if dates not set, default to start/end of this month
      from = from || moment().startOf('month')
      until = until || moment().endOf('month')
      const $this = this
      const timezone = jstz.determine()
      api.get('calendar-events', {
        params: {
          // required to tell the API to offset dates to user's timezone, will default to UTC
          timezone: timezone.name(),
          from: from.unix(),
          until: until.unix()
        }
      }).then(response => {
        $this.pushNewEvents(response.data)
      })
    },
    hasEventDataFor (date) {
      return this.selectedEvents.hasOwnProperty(date.format('YYYY-MM'))
    },
    pushNewEvents (data) {
      this.selectedEvents = _.merge(_.groupBy(data, (event) => {
        return moment(event.scheduled_start_at).format('YYYY-MM')
      }), this.selectedEvents)
    }
  },
  computed: {
    allEvents () {
      const events = _.flatten(_.values(this.selectedEvents))
      return _.sortBy(events, ['scheduled_start_at', 'scheduled_end_at'])
    }
  }
}
